import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const presentation = {

  namespaced: true,

  state: {
    presentation: {},
    comments: false,
    changelog: false,
  },

  getters: {
    presentation: state => state.presentation,
    comments: state => state.comments,
    changelog: state => state.changelog,
  },

  mutations: {
    setPresentation(state, presentation) { state.presentation = presentation },
    setComments(state, comments) { state.comments = comments },
    setChangelog(state, changelog) { state.changelog = changelog },
    setPublish(state, publish) { state.presentation.publish = publish },
  },

  actions: {

    getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Presentation'],
      filter_display: true,
    }}),

    async getPresentation({ commit }) {
      const presentation = await Vue.axios.get(API_URL + '/presentations/' + router.currentRoute.params.id);
      commit('setComments', false);
      commit('setChangelog', false);
      commit('setPresentation', presentation.data);
    },

    async clonePresentation({ commit }) {
      const presentation_clone = await Vue.axios.post(API_URL + '/presentations/' + router.currentRoute.params.id + '/clone');
      commit('setPresentation', {});
      router.currentRoute.params.id = presentation_clone.data;
      if (presentation_clone.data) router.push('/presentation/' + presentation_clone.data + '/edit');
    },

    toggleComments({ state, commit }) {
      commit('setChangelog', false);
      commit('setComments', !state.comments);
    },

    toggleChangelog({ state, commit }) {
      commit('setComments', false);
      commit('setChangelog', !state.changelog);
    },

  }
}
